import script from "./AbilitiesRadarGraphic.vue?vue&type=script&setup=true&lang=ts"
export * from "./AbilitiesRadarGraphic.vue?vue&type=script&setup=true&lang=ts"

import "./AbilitiesRadarGraphic.vue?vue&type=style&index=0&id=fd5f2ac0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd5f2ac0"]])

export default __exports__